<template>
  <ul
    id="main-menu-navigation"
    class="nav navbar-nav"
  >
    <component

      v-for="item in items"
      :key="item.header || item.title"
      :item="item"
      v-if="checkIsHeaderGroup(item)"
      :is="resolveNavComponent(item)"
    />
    
  </ul>
</template>

<script>
import HorizontalNavMenuHeaderLink from '../horizontal-nav-menu-header-link/HorizontalNavMenuHeaderLink.vue'
import HorizontalNavMenuHeaderGroup from '../horizontal-nav-menu-header-group/HorizontalNavMenuHeaderGroup.vue'
import AuthHelpers from "@/utils/auth-helpers";

export default {
  components: {
    HorizontalNavMenuHeaderLink,
    HorizontalNavMenuHeaderGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const resolveNavComponent = item => {
      if (item.children) return 'horizontal-nav-menu-header-group'
      return 'horizontal-nav-menu-header-link'
    }
   
    const checkIsHeaderGroup= item =>{
      if (item.children) return item.children?.some(el => AuthHelpers.canNavigate(el.slug))
      return AuthHelpers.canNavigate(item.slug)
    }

    return {
      resolveNavComponent,
      checkIsHeaderGroup
    }
  },
}
</script>
